<template lang="html">
  <div class="zjhz">
    <div class="navbar">
      <ul class="navtab">
        <li @click="topath('/home')">直播课<span></span></li>
        <li @click="topath('/tgfc')">投顾风采<span></span></li>
        <!-- <li @click="topath('/mrcb')">每日晨报<span></span></li> -->
        <li class="active">战绩汇总<span></span></li>
      </ul>
    </div>
    <div class="new">
      <div class="title">最新战绩</div>
      <div class="picture" v-for="item in newlist">
        <img :src="item.imager">
      </div>
    </div>
    <yd-infinitescroll :callback="oldscoreinfo" ref="infinitescrollDemo">
      <div class="old" slot="list" v-if="older" style="padding: .2rem .3rem; background: #fff;margin-bottom: .14rem;">
        <div class="title" style="font-size: .3rem;color:#006ACC;margin-bottom: .2rem;">往期战绩</div>
        <div class="picture" v-for="item in list">
          <img :src="item.imager">
        </div>
      </div>
      <!-- 数据全部加载完毕显示 -->
      <span slot="doneTip">没有更多数据啦~~</span>
      <!-- 加载中提示，不指定，将显示默认加载中图标 -->
      <!--<img slot="loadingTip" src="http://static.ydcss.com/uploads/ydui/loading/loading10.svg"/>-->
    </yd-infinitescroll>
    <!--图片预览-->
    <!-- <div class="preview" v-if="preview">
      <img :src="picsrc" @click="picturehide">
    </div> -->
  </div>

</template>

<script>
import * as api from '../../api/api.js'
  export default {
    data() {
      return {
        page: 1,
        pageSize: 10,
        newlist: [],
        list: [],
        older: false,
        rid: 4
        // preview:false
      }
    },

    methods: {
      scoreinfo: function () {
        var the = this;
        this.axios.get(api.GetZj + this.rid).then(function (response) {
          const _list = response.data.data;
          the.newlist = [..._list];
        });
      },
      oldscoreinfo: function () {
        this.axios.post('https://mai-zbj-api.ydtg.com.cn/api/gethistoryscore?rid='+this.rid, {
          page: this.page,
          pageSize: this.pageSize
        }).then(function (response) {
          const _oldlist = response.data;
          if (_oldlist.length > 0) {
            this.older = true;
            this.list = [...this.list, ..._oldlist];
            if (_oldlist.length < this.pageSize) {

              this.$refs.infinitescrollDemo.$emit('ydui.infinitescroll.loadedDone');
              return;
            }
            this.$refs.infinitescrollDemo.$emit('ydui.infinitescroll.finishLoad');
            this.page++;
          }
        }.bind(this));
      },
      topath: function (url) {
        this.$router.push(url);
      },
      //图片预览
      // pictureshow:function(src){
      //   this.picsrc='http://ydgpzbj.ydtg.com.cn:84'+src;
      //   this.preview=true;
      // },
      // //关闭图片预览
      // picturehide:function(){
      //   this.preview=false;
      // }
    },
    mounted() {
      const { rid } = this.$route.query
      this.rid = rid
      this.scoreinfo();
      // this.oldscoreinfo();
    }
  }
</script>

<style lang="css" scoped>
  .new {
    padding: .2rem .3rem;
    background: #fff;
    margin-bottom: .14rem;
  }

  .old {
    padding: .2rem .3rem;
    background: #fff;
    margin-bottom: .14rem;
  }

  .title {
    font-size: .3rem;
    color: #006ACC;
    margin-bottom: .2rem;
  }

  .picture {
    background: #F1F1F1;
    padding: .1rem;
  }

  .picture img {
    width: 100%;
    height: 3.64rem;
    margin-bottom: .1rem;
  }

  .load {
    width: 1.5rem;
    height: .6rem;
    background: #006ACC;
    color: #fff;
    border: none;
    border-radius: 4px;
  }

  .loadmore {
    text-align: center;
    margin-top: .3rem;
  }

  .preview {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: #fff;
    z-index: 50;
  }

  .preview img {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/zb/zjhz.vue